module.exports = __webpack_public_path__ + "img/shuiliu.1c510fbc.jpg";